document.addEventListener('DOMContentLoaded', function() {
    // function handleCheckoutClick(cartSelector, buttonSelector) {
    //     if (document.querySelector(buttonSelector)) {
    //         document.querySelector(buttonSelector).addEventListener('click', function(e){
    //             e.preventDefault();
                
    //             let vendorIds = [];
    //             let quantities = [];

    //             // Loop through each cart item
    //             document.querySelectorAll(cartSelector).forEach(item => {
    //                 let qty = parseInt(item.querySelector('input[type="number"]').value, 10);
    //                 let vendorId = item.getAttribute('data-vendor');
                    
    //                 vendorIds.push(vendorId);
    //                 quantities.push(qty);
    //             });
                
    //             // Form the final URL
    //             let finalUrl = `${window.custom_cart_endpoint}/cart?listings=${vendorIds.join(',')}&quantities=${quantities.join(',')}`;
                
    //             // Redirect to the final URL
    //             window.location.href = finalUrl;
    //         });
    //     }
    // }

    // if (window.custom_cart_endpoint && document.querySelector('.checkout-button') && document.querySelector('#cart-form') && document.querySelector('[data-vendor]')) {
    //     handleCheckoutClick('#cart-form [data-vendor]', '.checkout-button');
    // }

    // if (document.querySelector('.button.full.checkout')) {
    //     handleCheckoutClick('.cart-drawer [data-vendor]', '.button.full.checkout');
    // }

    // setInterval(function(){
    //   if (window.custom_cart_endpoint && document.querySelector('.checkout-button') && document.querySelector('#cart-form') && document.querySelector('[data-vendor]')) {
    //       handleCheckoutClick('#cart-form [data-vendor]', '.checkout-button');
    //   }
  
    //   if (document.querySelector('.button.full.checkout')) {
    //       handleCheckoutClick('.cart-drawer [data-vendor]', '.button.full.checkout');
    //   }
    // }, 500);
});
document.addEventListener('DOMContentLoaded', function() {
    var showMoreButtons = document.querySelectorAll('.show-more-filters');

    showMoreButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            var parent = button.closest('.thb-filter-dropdown');
            var hiddenFilters = parent.querySelectorAll('.hide-filter');

            if (button.textContent === 'Show more filters') {
                hiddenFilters.forEach(function(filter) {
                    filter.style.display = 'block';
                });
                button.textContent = 'Show less filters';
            } else {
                hiddenFilters.forEach(function(filter) {
                    filter.style.display = 'none';
                });
                button.textContent = 'Show more filters';
            }
        });
    });
});

(async() => {
    while(!window.hasOwnProperty("_swat")) {
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    _swat.evtLayer.addEventListener('sw:addedtocart', () => document.location.reload())
})();

/* EM */
window.themeObj = {
    init: () => {
      window.themeObj.templates.init();
    }
  };
  
  window.themeObj.templates = {
    init: () => {
  
      if (document.body.classList.contains('template-collection')) {
        window.themeObj.templates.collection.init();
      }
    },
    collection: {
      init: () => {
        window.themeObj.templates.collection.footer();
      },
      footer: () => {
        const wrapper = document.querySelector('.collection-footer__text');
    
        // if (wrapper) {
        //   const rte = wrapper.querySelector('.collection-footer__text-content');
            
        //   if (rte && wrapper.clientHeight >= 185) {
        //     wrapper.classList.add('is-collapsed');
          
        //     const button = document.querySelector('.collection-footer__text-button');
      
        //     button.addEventListener('click', () => {
        //       wrapper.classList.remove('is-collapsed');
        //     });
        //   }
        // }

        if (wrapper) {
            const rte = wrapper.querySelector('.collection-footer__text-content');
            const button = document.querySelector('.collection-footer__text-button');
    
            if (rte && wrapper.clientHeight >= 185) {
                wrapper.classList.add('is-collapsed');
    
                button.addEventListener('click', () => {
                    wrapper.classList.toggle('is-collapsed');
                    button.textContent = wrapper.classList.contains('is-collapsed') ? 'Show more' : 'Show less';
                });
    
                // Set initial button text
                button.textContent = 'Show more';
            }
        }        
      }
    }
  };
  
  window.themeObj.init();
  /* End: EM */

(function () {
  const forceLinkOverride = () => {
    document.querySelectorAll('.swym-ui-component .swym-wishlist-list-card .swym-title a').forEach(link => {
      const realHref = link.getAttribute('href');
      if (realHref) {
        link.removeAttribute('data-swym-href');     // disable modal
        link.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();                      // kill Swym handler
          window.location.href = realHref;          // force redirect
        };
      }
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        forceLinkOverride();
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also run once in case content already loaded
  document.addEventListener("DOMContentLoaded", forceLinkOverride);
})();

  